const debugMode = import.meta.env.VITE_DEBUG_MODE === '1';

/**
 * Debug 訊息
 * @param  {any} message
 * @param  {any[]} ...optionalParams
 */
// eslint-disable-next-line
export const log = (message?: any, ...optionalParams: any[]) => {
  if (debugMode) {
    console.log('[debug]', message, ...optionalParams);
  }
};
